import {useTranslation} from 'react-i18next';

import {FunctionComponent, LabelHTMLAttributes} from 'react';
import styles from './styles.module.scss';

interface ElementProps extends LabelHTMLAttributes<HTMLLabelElement> {
  isRequired?: boolean;
  withOptionalText?: boolean;
}

const Label: FunctionComponent<ElementProps> = ({
  children,
  isRequired = false,
  withOptionalText = false,
  ...props
}) => {
  const {t} = useTranslation('components');
  let classes = styles.label;

  if (props.className) {
    classes = `${classes} ${props.className}`;
  }

  return (
    <label {...props} className={classes}>
      {children}

      {isRequired && <span className={styles.asterik}> *</span>}

      {withOptionalText && (
        <p className={styles.optionalText}>{t('optional')}</p>
      )}
    </label>
  );
};

export default Label;
